/**
 * R5 — BlocchiClienteBanner.jsx
 *
 * Yellow banner above the workbench grid listing customer-level blockers
 * (NO CINA, SOLO AISI 316, etc.). Dismissable per-session.
 */
import { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";

export default function BlocchiClienteBanner({ blocchi, sessionId }) {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(false);
  }, [sessionId]);

  if (!blocchi || blocchi.length === 0 || dismissed) return null;

  return (
    <div
      className="rounded-md px-3.5 py-2.5 flex items-start gap-2.5"
      style={{
        background: "#FEF3C7",
        border: "1px solid #FDE68A",
        color: "#78350F",
      }}
      data-testid="blocchi-cliente-banner"
    >
      <AlertTriangle
        className="h-4 w-4 mt-0.5 shrink-0"
        style={{ color: "#B45309" }}
      />
      <div className="flex-1 min-w-0">
        <div className="text-[12px] font-semibold mb-1">
          Blocchi cliente ({blocchi.length})
        </div>
        <ul className="space-y-0.5 text-[12px]">
          {blocchi.map((b, i) => (
            <li key={i} className="flex items-start gap-1.5">
              <span className="shrink-0">›</span>
              <span>{b}</span>
            </li>
          ))}
        </ul>
      </div>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        className="opacity-60 hover:opacity-100 transition-opacity"
        aria-label="Chiudi"
        data-testid="blocchi-dismiss-btn"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
